export default __webpack_public_path__ + "static/media/tipoPlan.9d74c972.png";